import type {
  UpdateTagTypeMutation,
  UpdateTagTypeMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

const mapTrpcResponseToGraphQL = (): UpdateTagTypeMutation => {
  return {
    update_tag_type: {
      __typename: 'tag_type_mutation_response',
      affected_rows: 1,
    },
  };
};

export const useUpdateTagTypeTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.tag.update.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.tag.pathKey(),
        });
      },
    }),
  });

  return {
    updateTagType: async (
      variables: UpdateTagTypeMutationVariables
    ): Promise<UpdateTagTypeMutation> => {
      await mutation.mutateAsync({
        Id: variables.TagTypeId,
        Name: variables.Name ?? '',
        Description: variables.Description ?? null,
        TagTypeGroupId: variables.TagTypeGroupId ?? null,
        OriginalTimestamp: variables.OriginalTimestamp ?? '',
      });

      return mapTrpcResponseToGraphQL();
    },
    loading: mutation.isPending,
    error: mutation.error,
  };
};
